module.exports = __webpack_public_path__ + "img/company_06.a3acbcd9.png";